import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

// 基础组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/common.css'

Vue.use(ElementUI);

// 轮播组件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

// 视频播放器
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

// 图片懒加载 - 修复资源路径
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1,
  // 使用public目录的绝对路径
  error: '/img/error.png',
  loading: '/img/loading.gif',
  attempt: 1
});

// 过滤器
Vue.filter('truncate', function (text, length, suffix) {
  if (text.length > length) {
    return text.substring(0, length) + (suffix || '...');
  } else {
    return text;
  }
});

Vue.config.productionTip = false

// Axios配置
axios.defaults.timeout = 5000
Vue.prototype.$http = axios

// 图片服务器地址
// Vue.prototype.imgserver = 'http://康一.com/'
Vue.prototype.imgserver = 'http://118.25.197.82/'


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')